import { useFormatPrice } from '@packages/shared/src/hooks/useFormatPrice/useFormatPrice';

export type UsePriceFormatterTargetTypes = 'PRODUCT' | 'APLUS' | 'ATB' | 'INSTALLMENTCALCULATOR';
export type FormatPricePrice = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[0];
export type FormatPriceCurrency = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[1];

function getPrice(price: FormatPricePrice, targetType: UsePriceFormatterTargetTypes) {
  switch (targetType) {
    case 'APLUS':
    case 'INSTALLMENTCALCULATOR': {
      return Math.round(price * 100);
    }
    case 'PRODUCT':
    case 'ATB':
    default: {
      return price;
    }
  }
}

// replace hook with function, so it can be used in server components --> https://empiriecom.atlassian.net/browse/INFORM-3562
export const usePriceFormatter = (targetType: UsePriceFormatterTargetTypes) => {
  const { formatPrice } = useFormatPrice();

  return (price: FormatPricePrice, currency: FormatPriceCurrency) =>
    formatPrice(getPrice(price, targetType), currency);
};
